import instantCampaignService from '@/services/instantCampaignService';

const state = {
  historial: [],
  otsFiltradas: [],
  totalOts: null,
  campanaActual: null,
  metricas: null,
  loading: false,
  error: null,
};

const getters = {
  historial: (s) => s.historial,
  otsFiltradas: (s) => s.otsFiltradas,
  totalOts: (s) => s.totalOts,
  campanaActual: (s) => s.campanaActual,
  metricas: (s) => s.metricas,
  loading: (s) => s.loading,
  error: (s) => s.error,
};

const mutations = {
  SET_HISTORIAL(s, historial) {
    s.historial = historial;
  },
  SET_OTS_FILTRADAS(s, { ots, total }) {
    s.otsFiltradas = ots || [];
    s.totalOts = total != null ? total : (ots ? ots.length : 0);
  },
  SET_CAMPANA_ACTUAL(s, campana) {
    s.campanaActual = campana;
  },
  SET_METRICAS(s, metricas) {
    s.metricas = metricas;
  },
  SET_LOADING(s, loading) {
    s.loading = loading;
  },
  SET_ERROR(s, error) {
    s.error = error;
  },
  CLEAR_ERROR(s) {
    s.error = null;
  },
};

const actions = {
  /**
   * filtrarOts — POST /api/instant-campaigns/filtrar-ots/
   * @param {Object} filtros — { tipo_ot, condiciones, modelos }
   */
  async filtrarOts({ commit }, filtros) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const result = await instantCampaignService.filtrarOts(filtros);
      commit('SET_OTS_FILTRADAS', { ots: result.ots, total: result.total });
      return result;
    } catch (e) {
      commit('SET_ERROR', 'Error al filtrar OTs.');
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * enviarCampana — creates then sends: POST /api/instant-campaigns/ + POST /{id}/enviar/
   * @param {Object} datos — { nombre, tipo_ot, condiciones, modelos, asunto, cuerpo }
   */
  async enviarCampana({ commit }, datos) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const campana = await instantCampaignService.crearCampana(datos);
      await instantCampaignService.enviarCampana(campana.id);
      return campana;
    } catch (e) {
      commit('SET_ERROR', 'Error al enviar la campaña.');
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * fetchHistorial — GET /api/instant-campaigns/
   */
  async fetchHistorial({ commit }) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const data = await instantCampaignService.obtenerCampanas();
      commit('SET_HISTORIAL', data);
    } catch (e) {
      commit('SET_ERROR', 'Error al cargar el historial de campañas.');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * fetchMetricas — GET /api/instant-campaigns/{id}/metricas/
   */
  async fetchMetricas({ commit }, id) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const metricas = await instantCampaignService.obtenerMetricas(id);
      commit('SET_METRICAS', metricas);
      return metricas;
    } catch (e) {
      commit('SET_ERROR', 'Error al cargar las métricas.');
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchCampana({ commit }, id) {
    try {
      const data = await instantCampaignService.obtenerCampana(id);
      commit('SET_CAMPANA_ACTUAL', data);
      return data;
    } catch (e) {
      commit('SET_ERROR', 'Error al cargar la campaña.');
      throw e;
    }
  },

  clearError({ commit }) {
    commit('CLEAR_ERROR');
  },
};

export default { namespaced: true, state, getters, mutations, actions };
